<template>
  <common-dialog ref="dialog" width="700px" title="批量修改标题" :data="data" :save-func="saveFunc" show-save-button
    @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <div class="tip">
        <el-alert title="注：如果使用多种处理方式，则处理顺序为：删除 > 替换 > 添加前后缀" type="warning" :closable="false" />
      </div>
      <el-form-item label="添加前后缀">
        <div class="edit-item">
          <div class="edit-input">
            <el-input v-model="data.prefixKeyword" placeholder="请输入前缀" spellcheck="false" clearable />
          </div>
          <div>+ 原标题 +</div>
          <div class="edit-input">
            <el-input v-model="data.suffixKeyword" placeholder="请输入后缀" spellcheck="false" clearable />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="替换关键字">
        <div class="edit-item">
          <div class="edit-input">
            <el-input v-model="data.replaceSource" placeholder="请输入关键字" spellcheck="false" clearable />
          </div>
          <div>替换为</div>
          <div class="edit-input">
            <el-input v-model="data.replaceString" placeholder="请输入关键字" spellcheck="false" clearable />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="删除关键词">
        <el-input v-model="data.deleteKeyword" placeholder="多个关键词用英文逗号,隔开" spellcheck="false" clearable />
      </el-form-item>
      <el-form-item label="删除标题前">
        <el-input-number v-model="data.beforeNum" :controls="false" style="width: 100px;" class="input-l" />
        <div style="display: inline-block;margin-left: 10px;">个字</div>
      </el-form-item>
      <el-form-item label="删除标题后">
        <el-input-number v-model="data.afterNum" :controls="false" style="width: 100px;" class="input-l" />
        <div style="display: inline-block;margin-left: 10px;">个字</div>
      </el-form-item>
      <el-form-item label="超出字数">
        <el-radio-group v-model="data.exceed">
          <el-radio :label="0">不修改</el-radio>
          <el-radio :label="1">截掉尾部内容</el-radio>
          <el-radio :label="2">截掉头部内容</el-radio>
        </el-radio-group>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';

function getStrLength(str) {
  var len = 0;
  if (!str) return len;
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
}

export default {
  components: { commonDialog },
  data() {
    return {
      data: {
        prefixKeyword: '',
        suffixKeyword: '',
        replaceSource: '',
        replaceString: '',
        deleteKeyword: '',
        beforeNum: null,
        afterNum: null,
        exceed: 0,
      },
      details: [],
    }
  },
  methods: {
    openEdit(rows) {
      this.details = rows.map(function (_data) {
        return {
          carousel_gallery: _data.carouselGalleryList,
          cat_id: _data.catId,
          cost_template_id: _data.costTemplateId,
          country_id: _data.countryId,
          detail_gallery: _data.detailGalleryList,
          goods_id: _data.goodsId,
          goods_name: _data.goodsName,
          out_goods_id: _data.outerGoodsId,
          goods_type: _data.goodsType,
          is_folt: _data.isFolt,
          is_pre_sale: _data.isPreSale,
          is_refundable: _data.isRefundable,
          market_price: _data.marketPrice,
          second_hand: _data.secondHand == 1,
          shipment_limit_second: _data.shipmentLimitSecond,
          sku_list: (_data.skuList || []).map(function (x) {
            return {
              is_onsale: x.is_onsale,
              limit_quantity: x.limit_quantity,
              multi_price: x.multi_price,
              out_sku_sn: x.out_sku_sn,
              price: x.price,
              quantity: 0,
              sku_id: x.sku_id,
              spec_id_list: '[' + (x.spec || []).map(function (s) { return s.spec_id }).join(',') + ']',
              thumb_url: x.thumb_url,
              weight: x.weight,
            };
          }),
        };
      });
      this.$refs.dialog.openEdit({ ...this.data });
    },
    saveFunc() {
      var self = this;
      return new Promise(function (resolve, reject) {
        var saveData = { dataList: [] };

        self.details.forEach(function (x) {
          var title = x.goods_name;

          // 删除前N位
          if (self.data.beforeNum) {
            title = title.slice(self.data.beforeNum);
          }
          // 删除后N位
          if (self.data.afterNum) {
            title = title.slice(0, self.data.afterNum * -1);
          }
          // 删除关键字
          if (self.data.deleteKeyword) {
            var keywords = self.data.deleteKeyword.split(',');
            keywords.forEach(function (key) {
              var parts = title.split(key);
              title = parts.join('');
            });
          }
          // 替换关键字
          if (self.data.replaceSource && self.data.replaceString) {
            var regex = new RegExp(self.data.replaceSource.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
            title = title.replace(regex, self.data.replaceString);
          }

          // 添加前后缀
          title = self.data.prefixKeyword + title + self.data.suffixKeyword;

          // 超出字数处理（60个中文字符 = 120长度）
          var length = getStrLength(title) - 120;
          if (length > 0) {
            switch (self.data.exceed) {
              case 0: // 不修改
                title = x.goods_name;
                break;
              case 1: // 截掉尾部内容
                title = title.slice(0, title.length - Math.ceil(length / 2));
                break;
              case 2: // 截掉头部内容
                title = title.slice(Math.ceil(length / 2));
                break;
            }
          }

          var item = {
            ...x,
            goods_name: title,
            carousel_gallery: JSON.stringify(x.carousel_gallery),
            detail_gallery: JSON.stringify(x.detail_gallery),
            sku_list: JSON.stringify(x.sku_list),
          };
          saveData.dataList.push(item);
        });

        goodsApi.put(saveData).then(function (res) {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(function (x) { html += '<div>' + x.title + '：' + x.errorMsg + '</div>' });
            self.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(function (err) { reject(err); });
      });
    },
    onClosed() {

    },
  }
}
</script>
<style scoped>
.tip {
  margin-bottom: 18px;
}

.edit-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edit-item .edit-input {
  width: 43%;
}
</style>
